import client from "./index";
import type { User } from "../types/auth";

/**
 * Get current user profile
 */
export const getCurrentUser = async (): Promise<User> => {
  const response = await client.get<User>('/users/me');
  return response.data;
};

/**
 * Update current user profile
 */
export const updateCurrentUser = async (data: Partial<User>): Promise<User> => {
  const response = await client.patch<User>('/users/me', data);
  return response.data;
};

/**
 * Delete current user account
 */
export const deleteCurrentUser = async (): Promise<{ message: string }> => {
  const response = await client.delete<{ message: string }>('/users/me');
  return response.data;
};
